export const VALID_ACTORS = ['tomoya', 'yuki'];
export const CHATGPT_PROJECT_URL = 'https://chatgpt.com/g/g-p-697426addb008191b6a4dcc85d2cd9f2-sehasutiyantoku/project';
